module.exports = __webpack_public_path__ + "static/media/post.d8a5b8d0.png";